<template>
  <div class="countdown-timer" v-if="diff > 0">
    <div class="days" v-if="days > 0 && showDays">
      <p class="digit">{{ days | twoDigits }}</p>
      <p class="text">{{ days > 1 ? 'days' : 'day' }}</p>
    </div>
    <div class="hours">
      <p class="digit">{{ hours | twoDigits }}</p>
      <span class="text">{{ $t('timer.hours') }}</span>
    </div>
    <div class="delimetr">{{ this.delimetr }}</div>
    <div class="minutes">
      <p class="digit">{{ minutes | twoDigits }}</p>
      <span class="text">{{ $t('timer.minutes') }}</span>
    </div>
    <div class="delimetr">{{ this.delimetr }}</div>
    <div class="seconds">
      <p class="digit">{{ seconds | twoDigits }}</p>
      <span class="text">{{ $t('timer.seconds') }}</span>
    </div>
  </div>
</template>

<script>
let interval = null;
export default {
  name: 'CountDown',
  props: {
    deadline: {
      type: String
    },
    stop: {
      type: Boolean
    },
    delimetr: {
      type: String,
      default: ':'
    },
    showDays: {
      type: Boolean,
      default: false
    },
    counterId: {}
  },
  data() {
    return {
      now: Math.trunc((new Date()).getTime() / 1000),
      date: null,
      diff: 0,
    }
  },
  mounted() {
    this.startCoundown();
  },
  computed: {
    seconds() {
      return Math.trunc(this.diff) % 60
    },
    minutes() {
      return Math.trunc(this.diff / 60) % 60
    },
    hours() {
      return Math.trunc(this.diff / 60 / 60) % 24
    },
    days() {
      return Math.trunc(this.diff / 60 / 60 / 24)
    }
  },
  watch: {
    now(value) {
      this.diff = this.date - this.now;
      if (this.diff <= 0 || this.stop) {
        this.diff = 0;
        this.$emit('timer-end', this.counterId);
        // Remove interval
        clearInterval(interval);
      }
    },
    deadline: function (newVal, oldVal) {
      this.startCoundown();
    }
  },
  filters: {
    twoDigits(value) {
      if (value.toString().length <= 1) {
        return '0' + value.toString()
      }
      return value.toString()
    }
  },
  destroyed() {
    clearInterval(interval);
  },
  methods: {
    startCoundown() {
      if (!this.deadline) {
        throw new Error("Missing props 'deadline' or 'end'");
      }
      let endTime = Math.round(Date.parse(this.deadline)/ 1000);
      this.date = endTime;
      if (!this.date) {
        throw new Error("Invalid props value, correct the 'deadline' or 'end'");
      }
      interval = setInterval(() => {
        let currentDate = new Date();
        let currentTime = currentDate.getTime();
        // let localOffset = (-1) * currentDate.getTimezoneOffset() * 60000;
        // this.now = Math.round(new Date(currentTime + localOffset).getTime() / 1000);
        this.now = Math.round(new Date(currentTime).getTime() / 1000);
      }, 1000);
    }
  }
}
</script>
<style scoped lang="scss">
@import "../assets/scss/utils/variables";

.countdown-timer {
  display: flex;
  justify-content: center;
  color: $light-blue;

  .digit {
    margin: 0;
    font-family: $font-family;
    font-size: 18px;
    line-height: 1.2;
    letter-spacing: 2px;

  }

  .delimetr {
    padding: 0 2px;
  }

  .text {
    display: block;
    font-family: $font-family;
    font-size: 9px;
    line-height: 1;
    color: #a3becc;
  }
}
</style>